/* =========================================================================
   KENZA HERO — Interaction layer
   - Statement rotator: cycles italic phrases one at a time
   - Stat count-up on enter viewport
   - Video lazy reveal
   ========================================================================= */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(hero) {
    if (!hero || hero.dataset.kenzaInit === '1') return;
    hero.dataset.kenzaInit = '1';

    initStatementRotator(hero);
    initStatCountUp(hero);
    initVideoReveal(hero);
  }

  /* --- Statement rotator ------------------------------------------------ */
  function initStatementRotator(hero) {
    const items = hero.querySelectorAll('.kenza-hero__statement-item');
    if (items.length === 0) return;

    items[0].classList.add('is-active');

    if (items.length === 1 || reduceMotion) return;

    const interval = parseInt(hero.dataset.statementInterval, 10) || 4200;
    let current = 0;

    function advance() {
      const next = (current + 1) % items.length;
      const currentEl = items[current];
      const nextEl = items[next];

      currentEl.classList.remove('is-active');
      currentEl.classList.add('is-leaving');

      setTimeout(() => {
        nextEl.classList.add('is-active');
      }, 90);

      setTimeout(() => {
        currentEl.classList.remove('is-leaving');
      }, 900);

      current = next;
    }

    setInterval(advance, interval);
  }

  /* --- Stat count-up ---------------------------------------------------- */
  function initStatCountUp(hero) {
    const nums = hero.querySelectorAll('[data-count-target]');
    if (!nums.length) return;

    const animate = (el) => {
      const targetStr = el.dataset.countTarget;
      if (reduceMotion) {
        el.textContent = targetStr;
        return;
      }
      const target = parseFloat(targetStr);
      if (isNaN(target)) {
        el.textContent = targetStr;
        return;
      }
      const decimals = (targetStr.split('.')[1] || '').length;
      const duration = 1800;
      const start = performance.now();

      function tick(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 5);
        const value = target * eased;
        if (decimals > 0) {
          el.textContent = value.toFixed(decimals).replace('.', ',');
        } else {
          el.textContent = Math.floor(value).toLocaleString('nl-NL');
        }
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          if (decimals > 0) {
            el.textContent = target.toFixed(decimals).replace('.', ',');
          } else {
            el.textContent = target.toLocaleString('nl-NL');
          }
        }
      }
      requestAnimationFrame(tick);
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Delay slightly so count-up syncs with the stat row's CSS animation
          setTimeout(() => animate(entry.target), 200);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    nums.forEach((n) => io.observe(n));
  }

  /* --- Video lazy reveal ------------------------------------------------ */
  function initVideoReveal(hero) {
    const videos = hero.querySelectorAll('video');
    videos.forEach((video) => {
      video.style.opacity = '0';
      video.style.transition = 'opacity 1s cubic-bezier(0.16, 1, 0.3, 1)';

      const reveal = () => { video.style.opacity = '1'; };

      if (video.readyState >= 2) {
        requestAnimationFrame(reveal);
      } else {
        video.addEventListener('loadeddata', reveal, { once: true });
        setTimeout(reveal, 2200);
      }

      if (video.autoplay) {
        const p = video.play();
        if (p !== undefined) p.catch(() => {});
      }
    });
  }

  /* --- Boot ------------------------------------------------------------- */
  function boot() {
    document.querySelectorAll('.kenza-hero').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const hero = e.target.querySelector('.kenza-hero');
    if (hero) init(hero);
  });
})();